import {QueueItemType} from "../../types";

export interface QueueItemLinkProps {
    data: QueueItemType;
}

export default function QueueItemLink({data}: QueueItemLinkProps) {
    if (!data?.metadata?.description || !data?.metadata?.url) return null;

    const url = `https://${data.metadata.url.replace(/^(ht|f)tps?:\/\//, '')}`;

    return (
        <div className="w-full bg-dark-black text-center p-4 max-w-[100%]">
            <a rel="noreferrer" className="text-xl underline" target="_blank" href={url}>{data?.metadata?.description || data.metadata.url}</a>
        </div>
    );
}